import { ButtonV2, VerticalDivider } from '@labrav/react-components'
import { useNavigate } from 'react-router-dom'

import { FlyoutListingProductType } from '../../../types/addEditProduct'
import { useStyles } from './MigrationInProgressBanner.styles'

export const MigrationInProgressBanner = ({
  resumePath,
}: {
  resumePath?: string
}) => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const redirectToMigration = () => {
    navigate(
      resumePath ||
        `./edit?listingTypeInfo=${FlyoutListingProductType.MIGRATED}`
    )
  }
  return (
    <div className={classes.root}>
      <div className={classes.pendingText}>
        Complete pending product migrations
      </div>
      <VerticalDivider height="20px" customClasses={classes.divider} />
      <ButtonV2 styleType="link" onClick={redirectToMigration}>
        Resume migration
      </ButtonV2>
    </div>
  )
}
